import { assert_false, assert_not_null } from '@shared/asserts/utils_asserts';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../../_fields/_base/FIELD__base';
import { ENUM__invocation_role as ENUM } from '../../../_invocations/_base/ENUM__invocation_role';
import { INVOCATION_LATENTS__create_noise } from '../../../_invocations/latents/INVOCATION_LATENTS__create_noise';
import { INVOCATION_SD__latents_to_image } from '../../../_invocations/sd/vae/INVOCATION_SD__latents_to_image';
import { ENUM__graph_template_name } from '../ENUM__graph_template_name';

export function GENERATION_TOOL__sd1__select_vae(tool: DTO__generation_tool) {
  let { graph } = tool;

  assert_not_null(graph);
  assert_false(graph.is_stub());

  /*
   *
   */

  const node__latents_to_image = INVOCATION_SD__latents_to_image.create_node_for(graph, ENUM.CORE__LATENTS_TO_IMAGE);

  const node__noise = INVOCATION_LATENTS__create_noise.create_node_for(graph, ENUM.CORE__LATENTS_NOISE);
  /*
   * UI
   */

  /*
   *
   */

  /*
   * UI
   */

  let fields__visible: FIELD__base[] = [node__latents_to_image.vae.model, node__noise.seed];
  let field_column_id = node__latents_to_image.vae.model.meta.field_id;
  let field_row_id = node__noise.seed.meta.field_id;

  tool.view__add({
    name: ENUM__graph_template_name.SELECT_VAE,
    group: '3. Models',

    //
    fields__visible,
    fields__stored: fields__visible,
    //
    field_column_id,
    field_row_id,
    //
    field_id_info__ml_asset: node__latents_to_image.vae.model.meta.field_id,
  });
}
